/**
 * @module OK/GroupJoinEventBuses
 * Контролирует событие вступления в группу и принятия правил в группе.
 */

import {EventBus} from "OK/EventBus";
import {GroupId} from "@ok/interfaces/group/IGroup";

export const GroupJoinEventBusesBusesPrefix = "group.join.event";

const create = EventBus.factory(GroupJoinEventBusesBusesPrefix);

interface IEventBusGroupJoinData {
    groupId?: GroupId,
    buttonId?: number,
    requestSent?: boolean,
    happeningStatus?: string,
    leaveEnabled?: boolean,
    roleName?: string,
    roleIcon?: string,
}

export interface IEventBusGroupJoin extends IEventBusGroupJoinData {
    isExit?: boolean,
}

export interface IEventBusGroupAccept extends IEventBusGroupJoinData { }

export const GROUP_JOIN = create<IEventBusGroupJoin>("groupJoin");
export const GROUP_ACCEPT_RULES = create<IEventBusGroupAccept>("groupAcceptRules");
